import i18n from '../plugins/i18n'

export function getLocaleDateTimeFormat (datestring: string) {
  return i18n.d(new Date(datestring), 'short')
}

export function getLongLocaleDateTimeFormat (datestring: string) {
  return i18n.d(new Date(datestring), 'long')
}
